import React from 'react'

function NonInsuranceDisclaimer() {
  return (
    <p>
      Oly Pty Ltd ABN 69 674 252 629 acts as an authorised representative on behalf of a number of Australian financial services licensees. The capacity in which Oly acts and the financial services Oly is authorised to provide are set out in the {' '}<a
        href="https://www.oly.com.au/insurance/novated-lease#fsgs"
        className=""
        target="_blank"
        rel="noopener noreferrer"
      >
        Financial Services Guides
      </a>. Oly acts as an agent for those licensees and not for you.
    </p>
  )
}

export default NonInsuranceDisclaimer
